import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {of, switchMap} from 'rxjs';
import {UserService} from "../../user/user.service";
import {User} from "../../user/user.types";
import {Roles} from "../../../modules/admin/roles/enums/roles.enum";

export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(UserService).user$.pipe(
        switchMap((user: User) => {
            const userRoles: Roles[] = user.roles?.map((role) => role.id) ?? [];
            const isAdmin: boolean = userRoles.includes(Roles.Admin);
            if (!isAdmin) {
                return of(router.parseUrl('/error/403'));
            }

            // Allow the access
            return of(true);
        }),
    );
};
